import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-comment-dialog',
  templateUrl: './comment-dialog.component.html',
  styleUrls: ['./comment-dialog.component.css']
})
export class CommentDialogComponent {
  commentControl = new FormControl('', [Validators.required]);

  constructor(
    public dialogRef: MatDialogRef<CommentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  addComment() {
    if (this.commentControl.valid) {
      // Add comment logic here
      this.dialogRef.close(this.commentControl.value);
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
